/* Erste Seite eines PDFs als Bild (für die Vorschau der Player Card im Reiter Material).
 *
 * Nutzt dieselbe Bibliothek wie files/PdfPreview.vue (pdfjs-dist, erst bei Bedarf geladen, nicht im Start-Bundle) —
 * keine neue Bibliothek. Die Seite wird gezeichnet und oben auf einen Bruchteil der Höhe zugeschnitten
 * (Vorgabe: 45 %, Kopf bis in die ersten Kacheln).
 */

/**
 * @param {Blob} blob  das PDF
 * @param {{ crop?: number, width?: number, env?: object }} [opts]  crop: Anteil der Höhe von oben (0..1);
 *   width: Zielbreite in Pixeln; page: Seitennummer (Vorgabe 1; nur für die Prüfskripte mehrseitiger PDFs); env: Austausch für Tests ({ loadPdfjs, createCanvas })
 * @returns {Promise<Blob>}  JPEG der zugeschnittenen ersten Seite
 */
export async function firstPageImage(blob, { crop = 0.45, width = 760, page: pageNumber = 1, env = {} } = {}) {
  const loadPdfjs = env.loadPdfjs || (async () => {
    const pdfjs = await import('pdfjs-dist');
    const workerUrl = (await import('pdfjs-dist/build/pdf.worker.min.js?url')).default;
    pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
    return pdfjs;
  });
  const createCanvas = env.createCanvas || ((w, h) => {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    return c;
  });

  const pdfjs = await loadPdfjs();
  const pdf = await pdfjs.getDocument({ data: await blob.arrayBuffer() }).promise;
  try {
    const page = await pdf.getPage(pageNumber);
    const base = page.getViewport({ scale: 1 });
    const viewport = page.getViewport({ scale: width / base.width });
    const cropH = Math.max(1, Math.round(viewport.height * crop));
    const full = createCanvas(Math.round(viewport.width), Math.round(viewport.height));
    await page.render({ canvasContext: full.getContext('2d'), viewport }).promise;

    const top = createCanvas(full.width, cropH);
    top.getContext('2d').drawImage(full, 0, 0, full.width, cropH, 0, 0, full.width, cropH);
    return await new Promise((resolve, reject) => {
      top.toBlob((b) => (b ? resolve(b) : reject(new Error('encodeFailed'))), 'image/jpeg', 0.88);
    });
  } finally {
    if (typeof pdf.destroy === 'function') pdf.destroy();
  }
}
